module.exports = __webpack_public_path__ + "img/main-menu.a97c6e2d.png";